import { Council, Region } from 'src/app/models/SiteGroups';
import { BeachSite } from 'src/app/models/BeachSite';

export class SitesFilter {
	public councils: string[]
	public regions: string[]
	public siteTypes: string[]
	public sites: BeachSite[]

	constructor(councils_: string[], regions_: string[], sites_: BeachSite[], siteTypes_: string[]) 
	{
		this.councils = councils_;
		this.regions = regions_;
		this.siteTypes = siteTypes_;
		this.sites = sites_;
	}

	//check if a beach site is available after the current filter is applied
	isSiteMatch(site: BeachSite): boolean {
		let match = false

		if (this.isEmpty()) 
		{
			return true;
		}
		if(this.siteTypes?.length && 
			-1 === this.siteTypes?.findIndex((type) => type.toLocaleLowerCase() === site.SiteType?.toLocaleLowerCase()))
		{
			return false;	
		}

		if(0 === this.sites.length)
		{
			return true;
		}

		//check if site ID matches a site in the sites list
		if (this.sites.length > 0 && 
			this.sites.find((x: BeachSite) => {
				return x.Identifier === site.Identifier;				
			})?.Identifier) 
		{			
			match = true
		}

		return match;
	}

	//check if filter is empty -- if it is we just show all results
	isEmpty(): boolean 
	{
		return (this.councils.length == 0 && this.regions.length == 0 && this.siteTypes.length == 0 && this.sites.length == 0);
	}

	//rest filter
	reset() {
		this.councils = []
		this.regions = []
		this.siteTypes = []
		this.sites = []
	}
}